/* app/js/src/components/mediaEditor/files-tab/label/label.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.label-container {
  display: flex;
  justify-content: space-between;
}
:host {
  border-radius: 4px;
  background-color: #f1f3f4;
  border: solid 1px #dde3e7;
  height: 26px;
  line-height: 24px;
  padding: 0 7px 0 10px;
  margin-right: 4px;
}
:host .label {
  font-size: 12px;
  margin-right: 7px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
:host .remove {
  position: relative;
  display: inline;
  bottom: 8px;
  left: 5px;
  cursor: pointer;
}
:host .remove svg path {
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
:host .remove:hover svg path {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.settingIcon {
  position: relative;
  display: inline;
  line-height: 26px;
  cursor: pointer;
}
.settingIcon ::ng-deep svg {
  width: 13px;
  height: 13px;
}
.settingIcon ::ng-deep svg :hover path {
  fill: #40c4ff !important;
}
.settingIcon:hover ::ng-deep svg path {
  fill: #40c4ff !important;
}
/*# sourceMappingURL=label.component.css.map */
